import { HttpClient } from '@angular/common/http';
import { AuthenticateService } from './authenticate.service';
import { Injectable } from '@angular/core';
import { ENV, URL_CIDADAO_REGISTROS } from '../../src/util/constants';


@Injectable({
  providedIn: 'root'
})
export class ImcService {

  constructor(private http: HttpClient, private auth: AuthenticateService) {
  }

  async recuperar() {
    return this.http.get(`${URL_CIDADAO_REGISTROS}rest/avaliacaonutricional`, { headers: this.getHeadersToken() }).toPromise().then((result: any[]) => {
      return result;
    }).catch((error) => {
      if (ENV === 'DEV') {
        return [
          {
            numeroCartao: null,
            id: 1612395,
            data: "2022-11-03",
            altura: 1.78,
            peso: 114.0,
            imc: 35.98,
            avaliacao: "Obesidade",
          },
          {
            numeroCartao: null,
            id: 1792103,
            data: "2023-07-27",
            altura: 1.8,
            peso: 1.25,
            imc: 0.39,
            avaliacao: "Baixo peso",
          },
          {
            numeroCartao: null,
            id: 1793341,
            data: "2023-07-31",
            altura: 1.78,
            peso: 125.0,
            imc: 39.45,
            avaliacao: "Obesidade",
          },
          {
            numeroCartao: null,
            id: 1805777,
            data: "2023-08-28",
            altura: 1.8,
            peso: 130.0,
            imc: 40.12,
            avaliacao: "Obesidade",
          },
        ];
      }
      return [];
    });
  }

  async excluir(data) {
    return this.http.delete(`${URL_CIDADAO_REGISTROS}rest/avaliacaonutricional/${data.id}`, { headers: this.getHeadersToken() }).toPromise().then(result => {
      return true;
    }).catch((error) => {
      return false;
    });
  }

  async adicionar(prof) {
    let date = prof.data.split('-');
    if (date[2]) {
      prof.data = date[0] + '-' + date[2] + '-' + (parseInt(date[1]));
    } else {
      date = prof.data.split('/');
      prof.data = date[2] + '-' + date[1] + '-' + (parseInt(date[0]));
    }
    return this.http.post(`${URL_CIDADAO_REGISTROS}rest/avaliacaonutricional`,
      prof, { headers: this.getHeadersToken() }).toPromise().then(result => {
        return true;
      }).catch((error) => {
        return false;
      });
  }

  async edit(prof) {
    return this.http.put(`${URL_CIDADAO_REGISTROS}rest/avaliacaonutricional`,
      prof, { headers: this.getHeadersToken() }).toPromise().then(result => {
        return true;
      }).catch((error) => {
        return false;
      });
  }

  getHeaders() {
    return {
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: this.auth.getAuthorizationToken()
    };
  }

  getHeadersToken() {
    return {
      Authorization: this.auth.getAuthorizationToken(),
      'Content-Type': 'application/json'
    };
  }

  getHeadersJson() {
    return {
      'Content-Type': 'application/json'
    };
  }

}
